import SuperAdminIconDark from '@Resources/assets/icons/dark/skateboard.svg';
import SuperAdminIconLight from '@Resources/assets/icons/light/skateboard.svg';
import { SvgIcon, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@Components/IconButton/IconButton';
import Styles from '@Components/IconButton/IconButton.scss';
import { SettingsType } from '@Components/Settings/SettingsType';
import { success } from '@Services/notification/NotificationServices';
import { ISettingsProps } from '../../Interfaces';

const SuperAdmin = (props: ISettingsProps) => {
    const { onSettingsBtnClick, isSubmitting, settingsType, id } = props;

    const isSelected = settingsType === SettingsType.SUPERADMIN;

    const dispatchNotification = () => {
        success('test ');
    };

    return (
        <Tooltip title="Super Admin Settings">
            <div className={Styles.iconButtonWrapper}>
                <IconButton
                    onClick={() => onSettingsBtnClick(SettingsType.SUPERADMIN)}
                    id={id}
                    disabled={isSubmitting}
                    isSelected={isSelected}
                    icon={
                        <SvgIcon inheritViewBox>
                            {isSelected ? (
                                <SuperAdminIconLight />
                            ) : (
                                <SuperAdminIconDark />
                            )}
                        </SvgIcon>
                    }
                />
            </div>
        </Tooltip>
    );
};

export default SuperAdmin;
